import { Button } from "antd";
import styled, { css } from "styled-components";

export const MyOrdersContainer = styled.div`
  display: flex;
  justify-content: center;

  height: 100%;

  margin-top: 6rem;
  padding: 0 1rem 2rem 1rem;

  @media (max-width: 990px) {
    margin-top: 2rem;
  }

  ${({ theme }) =>
    theme.mode === "dark" &&
    css`
      h1,
      h2,
      p,
      input,
      span,
      .ant-select-selection-selected-value {
        color: #ffffff !important;
      }
      ,
      small {
        color: #262626;
      }
    `};
`;

export const MyOrdersContent = styled.div`
  max-width: 830px;
  width: 100%;

  h2 {
    font-size: 20px;
    color: #262626;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }

  .details {
    font-size: 12px;
    margin: 10px 10px 18px 2px;
  }
`;

export const ContainerEmpty = styled.div`
  text-align: center;

  margin: 12rem 0;
`;

export const ResultContentFilter = styled.div`
  span:first-child {
    font-size: 1.1rem;
    font-weight: 600;
    padding-right: 0.4rem;
    border-right: 1px solid #898692;
  }

  span:last-child {
    font-size: 0.9rem;
    color: #898692;
    padding-left: 0.4rem;
  }
`;

export const ButtonAnt = styled(Button)`
  border-radius: 80px !important;
  padding: 0 2rem;
  height: 50px;

  font-weight: 600;
  font-size: 1rem;

  margin: 0;

  &:hover {
    opacity: 0.7;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;

  margin: 2rem 0;
`;

export const MyOrdersFallbackContainer = styled.div`
  max-width: 830px;
  display: flex;
  gap: 2rem;
  flex-direction: column;
  width: 100%;
`;
